import { Progress } from "@chakra-ui/react";
import Location from "../../../components/candidate/signupFlow/location/index";

const LocationPage = () => {
  return (
    <>
      <Progress
        colorScheme="progressBar"
        size="xs"
        value={30}
        w="full"
        borderRadius={"lg"}
        mb="6 !important"
        mt="2 !important"
      />
      <Location />
    </>
  );
};

export default LocationPage;
